import EmptyResult from './EmptyResult';
import EmptyResultContainer from './EmptyResult.container';

export default EmptyResultContainer(EmptyResult);
